import React, { useEffect, useState } from "react";
import { Layout, Button, Card, Row, Col } from "antd";
import OuanityProducts from "./OuantityProducts";
import VendorQuantityProducts from "./VendorQuanityProducts";
import Completed from "./AdminCompletedOrder";
import VendorCompleted from "./CompletedOrders";
import Return from "./AdminReturnOrders";
import VendorReturn from "./VendorReturnOrder";
import Cancel from "./AdminCancelOrder";
import CommissionOrderReport from "./CommissionOrderReports";
import VendorComissionOrderReport from "./vendorCommissionReport";
import AdminEcomShipment from "./AdminEcomShipmentOrders";
import ReturnOrders from "./ReturnOrders";
import "./Styles/staffManagement.css"; // Assuming you have a CSS file for styling

const { Content } = Layout;

const OrdersManagement = () => {
  const [activeTab, setActiveTab] = useState("quantity");
  const [role, setRole] = useState(null);

  useEffect(() => {
    const Role = localStorage.getItem("role");
    console.log(Role);
    setRole(Role);
  }, []);

  return (
    <Layout className="admin-dashboard-layout">
      {/* <Content className="admin-dashboard-content"> */}
      <Card title="Report Management" className="admin-dashboard-card">
        <Row gutter={[16, 16]} justify="space-between">
          <Col xs={24} sm={6} style={{ paddingBottom: 20 }}>
            <Button
              type={activeTab === "quantity" ? "primary" : "default"}
              onClick={() => setActiveTab("quantity")}
              block
            >
              Quantity Products
            </Button>
          </Col>
          <Col xs={24} sm={6}>
            <Button
              type={activeTab === "completed" ? "primary" : "default"}
              onClick={() => setActiveTab("completed")}
              block
            >
              Completed Orders
            </Button>
          </Col>
          <Col xs={24} sm={6}>
            <Button
              type={activeTab === "return" ? "primary" : "default"}
              onClick={() => setActiveTab("return")}
              block
            >
              Return Orders
            </Button>
          </Col>

          <Col xs={24} sm={6}>
            <Button
              type={activeTab === "cancel" ? "primary" : "default"}
              onClick={() => setActiveTab("cancel")}
              block
            >
              Cancel Orders
            </Button>
          </Col>
          <Col xs={24} sm={6}>
            <Button
              type={activeTab === "commission" ? "primary" : "default"}
              onClick={() => setActiveTab("commission")}
              block
            >
              Commission Orders
            </Button>
          </Col>
        </Row>
        {activeTab === "quantity" &&
          (role === "admin" ? <OuanityProducts /> : <VendorQuantityProducts />)}
        {activeTab === "completed" &&
          (role === "admin" ? <Completed /> : <VendorCompleted />)}
        {activeTab === "return" &&
          (role === "admin" ? <Return /> : <VendorReturn />)}
        {activeTab === "cancel" && (role === "admin" ? <Cancel /> : <Cancel />)}
        {activeTab === "commission" &&
          (role === "admin" ? (
            <CommissionOrderReport />
          ) : (
            <VendorComissionOrderReport />
          ))}
      </Card>
      {/* </Content> */}
    </Layout>
  );
};

export default OrdersManagement;
